export default "__VITE_ASSET__B$O7kRJ$__"